import React from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import BdsNavigationCard from '../../../../shared/components/v3/Cards/BdsNavigationCard/BdsNavigationCard';
import { CREATE_CHALLENGE_ROUTE, NEW_STORY_ROUTE } from '../../../../shared/constants/auth';
import { COMMUNICATIONS, SPORT_MEDAL } from '../../../../shared/constants/images';
import {
  CLICK_ACTION,
  SCREEN_HOME,
  SECTION_ACCESS,
  SECTION_CHALLENGES,
  SECTION_STORIES
} from '../../../../shared/constants/tagManager';
import TagManagerService from '../../../../shared/services/gtm/tagManagerService';
import { TRANSLATIONS_HOME } from '../../../../shared/translations/home';

const RedirectionsCards = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const navigationCardAction = (route: string, section: string) => {
    TagManagerService.pushEvent(CLICK_ACTION, SECTION_ACCESS, { ...SCREEN_HOME, section, quick_access_url: route });
    navigate(route);
  };

  return (
    <>
      <BdsNavigationCard
        title={t(TRANSLATIONS_HOME.navigationCard.stories)}
        leadingIcon={COMMUNICATIONS}
        action={() => navigationCardAction(NEW_STORY_ROUTE, SECTION_STORIES.section)}
      />
      <BdsNavigationCard
        title={t(TRANSLATIONS_HOME.navigationCard.challenges)}
        leadingIcon={SPORT_MEDAL}
        action={() => navigationCardAction(CREATE_CHALLENGE_ROUTE, SECTION_CHALLENGES.section)}
      />
    </>
  );
};

export default RedirectionsCards;
